// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../index';

import { gql } from 'graphql-tag';
import { FilterPriceRangeFragmentDoc } from '../../fragments/filters/filterPriceRange.fragment.generated';
import { MetalFilterFragmentDoc } from '../../fragments/filters/metalFilter.fragment.generated';
export const ReadyToGoRingFiltersFragmentDoc = gql`
    fragment readyToGoRingFilters on CatalogueReadyToGoRingFilters {
  price(input: {currency: $currency, region: $region}) {
    ...filterPriceRange
  }
  primaryMetals {
    ...metalFilter
  }
}
    ${FilterPriceRangeFragmentDoc}
${MetalFilterFragmentDoc}`;